import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { mainActions } from "../../actions/mainActions";
import { Form, Divider, Header, Checkbox } from "semantic-ui-react";

export type GlobalTableSettingsProps = {};

const RadioOption: React.FC<{
  label: string | number;
  checked: boolean;
  onSelect: () => void;
}> = ({ label, checked, onSelect }) => (
  <div
    className={`ui radio checkbox ${checked ? "checked" : ""}`}
    onClick={() => onSelect()}
    style={{ cursor: "pointer" }}
  >
    <input
      type="radio"
      className="hidden"
      checked={checked}
      readOnly
      tabIndex={0}
    />
    <label style={{ cursor: "pointer" }}>{label}</label>
  </div>
);

/* EditSizeForm changes the edit view size globally */
const GlobalTableSettings: React.FC<GlobalTableSettingsProps> = () => {
  const dispatch = useDispatch();
  const editSize = useSelector((state: State.Root) => state.main.editSize);
  const pageSize = useSelector((state: State.Root) => state.main.pageSize);
  const isShortenTextEnabled = useSelector((state: State.Root) => state.main.isShortenTextEnabled);

  const editNormal: State.EditNormal = 0.3;
  const editLarge: State.EditLarge = 1.2;
  const pageSmall: State.PageSizeSmall = 20;
  const pageMedium: State.PageSizeMedium = 100;
  const pageLarge: State.PageSizeLarge = 10000;

  return (
    <>
      <Header as="h4">Global</Header>
      <Divider />
      <Checkbox
        label="Shorten text"
        checked={isShortenTextEnabled}
        onClick={() => dispatch(mainActions.setShortenTextStatus(!isShortenTextEnabled))}
      />
      <Divider />
      <Form>
        <Form.Field>Edit view width</Form.Field>
        <Form.Field>
          <RadioOption
            label="Normal"
            checked={editSize === editNormal}
            onSelect={() => dispatch(mainActions.setEditSize(editNormal))}
          />
        </Form.Field>
        <Form.Field>
          <RadioOption
            label="Large"
            checked={editSize === editLarge}
            onSelect={() => dispatch(mainActions.setEditSize(editLarge))}
          />
        </Form.Field>
        <Divider />
        <Form.Field>Table size</Form.Field>
        <Form.Field>
          <RadioOption
            label={pageSmall}
            checked={pageSize === pageSmall}
            onSelect={() => dispatch(mainActions.setPageSize(pageSmall))}
          />
        </Form.Field>
        <Form.Field>
          <RadioOption
            label={pageMedium}
            checked={pageSize === pageMedium}
            onSelect={() => dispatch(mainActions.setPageSize(pageMedium))}
          />
        </Form.Field>
        <Form.Field>
          <RadioOption
            label={pageLarge}
            checked={pageSize === pageLarge}
            onSelect={() => dispatch(mainActions.setPageSize(pageLarge))}
          />
        </Form.Field>
      </Form>
    </>
  );
};

export default GlobalTableSettings;
